import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { Table, Grid } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import TableHead from "@material-ui/core/TableHead";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { Cell, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
import { BarChart, YAxis, XAxis, CartesianGrid, Bar, LabelList } from 'recharts';
import moment from "moment";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function createData(name, calories, fat) {
  return { name, calories, fat };
}

// const rows = [
//   createData("Cupcake", 305, 3.7),
//   createData("Donut", 452, 25.0),
//   createData("Eclair", 262, 16.0),
//   createData("Frozen yoghurt", 159, 6.0),
//   createData("Gingerbread", 356, 16.0),
//   createData("Honeycomb", 408, 3.2),
//   createData("Ice cream sandwich", 237, 9.0),
//   createData("Jelly Bean", 375, 0.0),
//   createData("KitKat", 518, 26.0),
//   createData("Lollipop", 392, 0.2),
//   createData("Marshmallow", 318, 0),
//   createData("Nougat", 360, 19.0),
//   createData("Oreo", 437, 18.0),
// ].sort((a, b) => (a.calories < b.calories ? -1 : 1));

const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "218px",
    minHeight: "218px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
        // border: "3px solid orange",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function BarCharter(props) {
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);

  //   const [dispatched, setDispatched] = React.useState([0]);
  //   const [delivered, setDelivered] = React.useState([0]);
  //   const [damaged, setDamaged] = React.useState([0]);
  const [chartData, setChartData] = React.useState([{}])
  const [barChartDataNotAvailable, setBarChartDataNotAvailable] = React.useState(false)
  const obj1 = {
    "New Job Created": 1,
    "Approved": 2,
    "Rejected": 3,
    "Loading Ongoing": 4,
    "Loading completed": 5,
    "RR Created": 6,
    "Rake in Transit": 7,
    "Rake placed at destination": 8,
    "Invoice generated": 9,
    "Rake on return transit": 10,
    "Rake arrived at return station": 11
  }
  const obj2 = {
    "New Job Created": 1,
    "Approved": 2,
    "Rejected": 3,
    "Loading in Progress": 4,
    "Loading completed": 5,
    "Rake in Transit": 6,
    "Rake arrived empty": 7,
    "Rake arrived loaded": 8,
    "Unloading in progress": 9,
    "Unloading completed": 10,
    "Invoice generated": 11
  }
  useEffect(() => {
    let propsData = props.doCountByStatus
    let propsType = props.type
    let structure = (propsType === 'SFTO') ? obj1 : obj2;
    if (propsData) {
      var Obj = []
      propsData.forEach(obj => {
        Obj.push({ name: obj.status, value: obj.count, key: structure[obj.status] })
      })
      Obj.sort(function (a, b) {
        return a.key - b.key;
      });
      //console.log(Obj)
      setChartData(Obj)
    } else {
      setBarChartDataNotAvailable(true);
      setChartData([{ name: 'No Data', value: 100 }]);
    }
    //console.log("Array", Obj)
  }, [props.doCountByStatus]);
  const COLORS = ['#FFBB28', '#00C49F', '#d62828', '#B0A8B9', '#48cae4', '#FF8042', '#d5bdaf', '#845EC2', '#ADC5CF', '#AD5E00', '#5E8C61'];
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    value,
    name
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.3;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    //console.log(index, value, name);
    return (

      <>
        {
          (value != null && value != 0) && (
            <>
              <text
                x={x}
                y={y}
                fill="black"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {name}
              </text>

              {!barChartDataNotAvailable && <text
                x={x}
                y={y + 10}
                fill="white"
                textAnchor="end"
                dominantBaseline="middle"
              >
                {value}
              </text>}

            </>
          )
        }
      </>
    );
  };


  const chartData2 = [
    {
      "name": "Approved", "value": 14
    },
    {
      "name": "Invoice generated", "value": 20
    },
    {
      "name": "Loading Ongoing", "value": 10
    },
    {
      "name": "Loading completed", "value": 30
    },
    {
      "name": "New Job Created", "value": 20
    },
    {
      "name": "RR Created", "value": 10
    },
    {
      "name": "Rake arrived at return station", "value": 30
    },
    {
      "name": "Rake in Transit", "value": 7
    },
    {
      "name": "Rake on return transit", "value": 9
    },
    {
      "name": "Rake placed at destination", "value": 14
    },
    {
      "name": "Rejected", "value": 19
    },
  ]
  // const CustomTooltip = ({ active, payload, label }) => {
  //   if (active) {
  //     return (
  //       <div className="custom-tooltip" style={{ backgroundColor: '#ffff', padding: '5px', border: '1px solid #cccc' }}>
  //         <label>{`${payload[0].name} : ${payload[0].value}`}</label>
  //       </div>
  //     );
  //   }
  //   return null;
  // };

  const renderLegend = (props) => {
    const { payload } = props;

    return (
      <ul>
        {
          payload.map((entry, index) => (
            <li key={`item-${index}`}>{entry.value}</li>
          ))
        }
      </ul>
    );
  }

  return (
    <>
      {barChartDataNotAvailable && (<ResponsiveContainer width="100%" height={350}>
        <BarChart width={730} height={250} data={chartData}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="value" fill="#8884d8" >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
          {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
        </BarChart>
      </ResponsiveContainer>)}


      {!barChartDataNotAvailable && (
        <ResponsiveContainer width="100%" height={300}>

          <BarChart width={730} height={250} data={chartData}
            margin={{
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
            }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={false} />
            <YAxis />
            <Tooltip />
            {/* <Legend layout="vertical" verticalAlign="middle" align="left" /> */}
            <Bar dataKey="value" fill="#8884d8" >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
              {/* <LabelList dataKey="name" position="bottom"  fill="black"  fontSize="11px"/> */}
            </Bar>
          </BarChart>
        </ResponsiveContainer>)}
      <Grid container spacing={1} style={{ justifyContent: "center" }}>
        {chartData.map((data, index) => (
          <Grid item><span style={{ color: `${COLORS[index % COLORS.length]}`, fontSize: "1em" }}>■</span> <b style={{ color: "grey", fontSize: "12px" }}>{data.name}</b></Grid>
        ))}
      </Grid>

    </>
  );
}